<template>
    <div id="app">
        <div class='screencontainer'>
            <div class="top-menu-bar">
                <label for="hamburger" class='border-menu'></label>
                <input type="checkbox" id="hamburger" />

                <div class='poolsdropdown'>
                    <button class='simplebutton' :class="{ 'loading line': !initializedContracts }">[{{ currentPoolObj ?
                        currentPoolObj.name.replace('Factory: kava-3pool', '3pool') : '' }}]</button>
                    <div class='dropdown'>
                        <router-link to='/'>Home</router-link>
                        <router-link to='/pools'>Pools</router-link>
                        <router-link v-if="!!default_account" :to="`/pools?see=${default_account}`">My
                            dashboard</router-link>
                        <router-link to='/trade'>Trade</router-link>
                        <router-link to='/combinedstats'>Stats</router-link>
                        <a href="https://twitter.com/CurveFinance" rel='noopener noreferrer'>#Twitter</a>
                        <a href="https://t.me/curvefi" rel='noopener noreferrer'>@Telegram</a>
                        <a href="https://t.me/curveficn" rel='noopener noreferrer'>@Telegram CN</a>
                        <a href="https://discord.gg/9uEHakc" rel='noopener noreferrer'>@Discord</a>
                        <a href="https://dune.xyz/mrblock_buidl/Curve.fi" rel='noopener noreferrer'>Dune Analytics</a>
                        <a href="https://llama.airforce/#/curve/" rel='noopener noreferrer'>Llama Airforce</a>
                        <p>____________</p>
                        <button id='myAddress' class='simplebutton margintop' v-show='defaultAccount !== null'>
                            <a :href="config.explorerBaseUrl.address + default_account" rel='noopener noreferrer'> {{
                                defaultAccount }} </a>
                        </button>
                        <button class='simplebutton margintop' @click='changeWallets'>Change wallet</button>
                    </div>
                </div>
                <router-link to='/'>Root</router-link>
                <div class='poolsdropdown'>
                    <span>Factory</span>
                    <div class='dropdown'>
                        <router-link to="/factory/create">Create pool</router-link>
                        <router-link to="/factory/create_gauge"
                            v-if="config.factoryV2CanCreateGauges || config.factoryV2HasGauges">Deploy
                            Gauge</router-link>
                        <router-link to="/factory/create_vote"
                            v-if="config.factoryV2CanCreateGauges || config.factoryV2HasGauges">Create Gauge
                            Vote</router-link>
                    </div>
                </div>
                <router-link :to="'/factory/' + (currentPoolObj && currentPoolObj.id.replace('factory-v2-', ''))">Buy
                    and
                    sell</router-link>
                <router-link
                    :to="'/factory/' + (currentPoolObj && currentPoolObj.id.replace('factory-v2-', '')) + '/deposit'">Deposit</router-link>
                <router-link
                    :to="'/factory/' + (currentPoolObj && currentPoolObj.id.replace('factory-v2-', '')) + '/withdraw'">Withdraw/Claim</router-link>

                <div class='poolsdropdown right'>
                    <span>?</span>
                    <div class='dropdown'>
                        <a :href="config.explorerBaseUrl.address + this.poolAddress" rel='noopener noreferrer'>Pool
                            contract</a>
                        <a :href="config.explorerBaseUrl.address + this.tokenAddress" rel='noopener noreferrer'>Token
                            contract</a>
                        <p>____________</p>
                        <router-link to="/whitepaper">Whitepaper</router-link>
                        <router-link to="/audits">Audits</router-link>
                        <router-link to="/events">Events</router-link>
                        <router-link to="/bugbounty">Bug Bounty</router-link>
                        <router-link to="/integrations">Integrations</router-link>
                        <router-link to="/devdocs">Developer Docs</router-link>
                        <router-link to="/careers">Careers</router-link>
                        <a href='https://news.curve.finance' rel='noopener noreferrer'>News</a>
                        <a href='https://resources.curve.finance' rel='noopener noreferrer'>Resources</a>
                        <p>____________</p>
                    </div>
                </div>
                <a href="https://dao.curve.finance" class='showmobile'>DAO</a>
                <router-link to="/whitepaper" class='showmobile'>Whitepaper</router-link>
                <router-link to="/audits" class='showmobile'>Audits</router-link>
                <router-link to="/events" class='showmobile'>Events</router-link>
                <router-link to="/integrations" class='showmobile'>Integrations</router-link>
                <router-link to="/bugbounty" class='showmobile'>Bug Bounty</router-link>
                <a href='https://news.curve.finance' rel='noopener noreferrer' class='showmobile'>News</a>
                <a href='https://resources.curve.finance' rel='noopener noreferrer' class='showmobile'>Resources</a>
                <button class='simplebutton showmobile' @click='changeWallets'>Change wallet</button>
            </div>
            <div id="screen">
                <div :class="{ 'blue window': true, [$route.name]: true }">
                    <h1><img :src="logoSrc" alt="🌀 Curve"></h1>
                </div>
                <HighGasWarning />
                <div class="error window half-width info" id="error-window" v-show='error'>
                    {{ error }}
                </div>
                <div class='info-message gentle-message window half-width gentle-message' v-show='hasConnectedWallet'>
                    You haven't connected a wallet. <button @click='changeWallets'>Connect wallet</button>
                </div>

                <router-view v-if="areFactoryPoolsLoaded" />
                <div v-else class="window white center loading-factory-data">
                    <div class="highcharts-loading-inner"></div>
                    <span>Loading factory data…</span>
                </div>
            </div>

            <balances-info :class='{ [$route.name]: true }' :bal_info='bal_info' :total='balTotal' :l_info='l_info'
                :totalShare='totalShare' :staked_info='staked_info' :totalStake='totalStake' :fee='fee'
                :admin_fee='admin_fee' :currencies='currencies'
                v-if="areFactoryPoolsLoaded && balTotal > 0 && !['Stats', 'FAQ', 'Donate', 'Root', 'CombinedStats', 'FactoryCreatePool', 'GaugeCreateVote', 'DeployGauge'].includes($route.name)" />
        </div>
        <footer>
            <a :href="config.explorerBaseUrl.address + this.poolAddress" rel='noopener noreferrer'>Pool contract</a>
            <a :href="config.explorerBaseUrl.address + this.tokenAddress" rel='noopener noreferrer'>Token contract</a>
            <a href="https://twitter.com/CurveFinance" rel='noopener noreferrer'>#Twitter</a>
            <a href="https://t.me/curvefi" rel='noopener noreferrer'>@Telegram</a>
            <a href="https://t.me/curveficn" rel='noopener noreferrer'>@Telegram CN</a>
            <a href="https://discord.gg/9uEHakc" rel='noopener noreferrer'>@Discord</a>
            <a href='https://news.curve.finance' rel='noopener noreferrer'>News</a>
            <a href='https://resources.curve.finance' rel='noopener noreferrer'>Resources</a>
            <a href="https://dune.xyz/mrblock_buidl/Curve.fi" rel='noopener noreferrer'>Dune Analytics</a>
            <a href="https://github.com/curvefi/curve-contract">git@</a>
            <router-link to="/devdocs">Developer Docs</router-link>
        </footer>
    </div>
</template>

<script>
import BalancesInfo from '../components/BalancesInfo.vue'
import getFactoryV2Pools from '@/utils/data/getFactoryV2Pools'
import { getters, contract as currentContract, changeContract, poolMenu } from '../contract'
import init, { onboard, changeWallets } from '../init'
import { contractAbis, isFactoryAbiDataLoaded } from '@/constants/abis'
import config from '@/constants/config'
import poolsConfig from '@/constants/pools'
import { sleepUntil } from '@/utils/Async'
import HighGasWarning from '@/components/common/HighGasWarning.vue'

export default {
    metaInfo() {
        return {
            title: 'Curve.finance Factory :: ' + (this.currentPoolObj ? this.currentPoolObj.name : ''),
        }
    },
    data: () => ({
        config,
        pools: [],
        areFactoryPoolsLoaded: false,
    }),
    components: {
        BalancesInfo,
        HighGasWarning,
    },
    async created() {
        setTimeout(async () => {
            this.pools = await getFactoryV2Pools();
            await sleepUntil(() => poolsConfig.isFactoryPoolDataLoaded() && isFactoryAbiDataLoaded());

            this.changePools(`factory-v2-${this.$route.params.poolId}`);
            this.areFactoryPoolsLoaded = true;
        }, 0);
    },
    computed: {
        allGetters() {
            return getters;
        },
        ...getters,
        currentPoolObj() {
            const activePoolId = Number(this.$route.params.poolId);
            const poolIdKey = `factory-v2-${activePoolId}`;
            return this.pools?.find(({ id }) => id === poolIdKey);
        },
        poolMenu() {
            return poolMenu;
        },
        poolAddress() {
            return this.currentPoolObj?.address
        },
        tokenAddress() {
            return this.currentPoolObj?.address
        },
        publicPath() {
            return process.env.BASE_URL
        },
        logoSrc() {
            // if(!currentContract.swapbtc && currentContract.currentContract != 'linkusd') return this.publicPath + config.logoPath
            // else return this.publicPath + 'logo_ren_beta_optimized.svg'
            return this.publicPath + config.logoPath
        },
        hasConnectedWallet() {
            return this.default_account == '0x0000000000000000000000000000000000000000'
                && !['Donate', 'StatsDaily', 'Audits', 'Stats', 'Contracts', 'FAQ', 'RootFAQ'].includes(this.$route.name)
        },
        defaultAccount() {
            if (!this.default_account || this.default_account == '0x0000000000000000000000000000000000000000') return null
            return this.default_account.slice(0, 6) + '...' + this.default_account.slice(-6)
        },
    },
    methods: {
        changePools(pool) {
            changeContract(pool)
        },
        async changeWallets() {
            changeWallets()
        },
    },
}
</script>

<style>
.margintop {
    margin-top: 0.3em;
}

#myAddress a {
    display: inline;
    margin: 0;
    padding: 0;
    color: white;
}

a.showmobile {
    display: none;
}

@media only screen and (min-device-width : 320px) and (max-device-width : 730px) {
    #hamburger:checked~a.showmobile {
        display: block;
    }

    .blue.window.half-width,
    .info-message.window.half-width {
        width: 90%;
    }
}

h1>img {
    height: 52.125px;
}

.simple-error.window {
    box-shadow: none;
}

.CRV a:hover,
.CRV a:visited {
    color: white;
}

.loading-factory-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 30px;
}

.loading-factory-data .highcharts-loading-inner {
    transform: none;
    margin-top: 0;
}
</style>
